import swal from "sweetalert";

var idLogin=0,typeLogin = '',campo,emailRegex;
$(function() {
    $('.forgetPassword').on('click', function () {
        grecaptcha.ready(function() {
            grecaptcha.execute('6LfRdtwZAAAAAGAsZTr769WArVkDxPg3hV2MFeU7', {action: 'submit'}).then(function(token) {
                forgetPassword(token);
            });
        });
    });

    function forgetPassword(token) {

        campo = $('#user').val();

        emailRegex = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;
        if (emailRegex.test(campo.trim())) {
            $('#user').removeClass('error');
        } else {
            $('#user').addClass('error');
            swal({
                text: "Escriba un correo electrónico valido",
                icon: imageURL,
                button: "OK",
            });
            return false;
        }

        $.ajax({
            url: https + "forgetPassword",
            method: "POST",
            data: {data: campo,token:token, action: 'forgetPassword'},
            success: function (data) {
                if ($.trim(data) == "1") {
                    swal({
                        text: "Recibira una notificacion a su correo \n electrónico para recuperar su contraseña",
                        icon: imageURL,
                        button: "OK!",
                    });
                } else if ($.trim(data) == "2") {
                    swal({
                        text: "Este usuario no se encuentra registrado",
                        icon: imageURL,
                        button: "OK!",
                    });
                } else {
                    swal({
                        text: "Error, hubo problemas",
                        icon: "warning",
                        button: "OK!",
                    });
                }

            }
        });
    }

    $('.btnFormLogin').on('click', function () {
        Login();
    });


    function Login() {
        $('#user').removeClass('error');
        $('#pass').removeClass('error');
        var contLogin = 1;
        if ($.trim($("#user").val()) == "") {
            contLogin = 0;
            $('#user').addClass('error');
        }

        if ($.trim($("#pass").val()) == "") {
            contLogin = 0;
            $('#pass').addClass('error');
        }

        if (contLogin == 0) {
            return false;
        }

        campo = $('#user').val();

        emailRegex = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;
        if (emailRegex.test(campo.trim())) {
            $('#user').removeClass('error');
        } else {
            document.getElementById("user").focus();
            $('#user').addClass('error');
            return false;
        }

        var email = $('#user').val();
        var password = $('#pass').val();

        $.ajax({
            type: "post",
            url: https + "login",
            data: {
                email: email,
                pass: password
            },
            success: function (data) {
                if ($.trim(data) == "1") {
                    $('#modalLogin').modal('close');
                    $('#modalRegister').modal('close');
                    $('#modalRegisterExito').modal('close');
                    if (typeLogin == '') {
                        location.reload();
                    } else if (typeLogin == 'Service') {
                        buyService(idLogin);
                    } else if (typeLogin == 'Taller') {
                        buyTaller(idLogin);
                    } else if (typeLogin == 'Package'){
                        localStorage.setItem('id_pack', idLogin);
                        location.reload();
                        //buyPackage(idLogin);
                    } else if (typeLogin == 'Course'){
                        buyCourse(idLogin);
                    }
                } else {
                    swal({
                        text: "" + data,
                        icon: imageURL,
                        button: "OK!",
                    });
                }
            }
        });
    }

    $('#user').keypress(function (e) {
        if (e.which == 13) {
            Login();
        }
    });

    $('#pass').keypress(function (e) {
        if (e.which == 13) {
            Login();
        }
    });

    $('.buyServiceLogin').click(function () {
        if(!$("#terms"+this.id).is(':checked')){
            swal({
                text: "Debes aceptar los terminos y condiciones",
                icon: imageURL,
                button: "OK!",
            });
            return false;
        }
        idLogin = this.id;
        typeLogin = 'Service';
        $('#modalLogin').modal('open');
    });

    function buyService(id) {
        swal({
            text: "Espere un momento",
            icon: imageURL,
            button: false,
        });
        $.ajax({
            url: https + "buyService",
            method: "POST",
            data: {id: id, action: "buyService"},
            success: function (data) {
                if ($.trim(data) == "complet") {
                    location.href = https + "payuService";
                } else {
                    swal({
                        text: "Ha ocurrido un error" + data,
                        icon: imageURL,
                        button: "OK!",
                    });
                }
            }
        });
    }

    $('.buyTallerLogin').click(function () {
        if(!$("#terms").is(':checked')){
            swal({
                text: "Debes aceptar los terminos y condiciones",
                icon: imageURL,
                button: "OK!",
            });
            return false;
        }
        idLogin = this.id;
        typeLogin = 'Taller';
        $('#modalLogin').modal('open');
    });

    function buyTaller(id) {
        swal({
            text: "Espere un momento",
            icon: imageURL,
            button: false,
        });
        $.ajax({
            url: https + "buyTaller",
            method: "POST",
            data: {id: id, action: "buyTaller"},
            success: function (data) {
                if ($.trim(data) == "complet") {
                    location.href = https + "payuTaller";
                } else {
                    swal({
                        text: "Ha ocurrido un error" + data,
                        icon: imageURL,
                        button: "OK!",
                    });
                }
            }
        });
    }

    $('.buyPackageLogin').click(function () {
        if(!$("#terms"+this.id).is(':checked')){
            swal({
                text: "Debes aceptar los terminos y condiciones",
                icon: imageURL,
                button: "OK!",
            });
            return false;
        }
        idLogin = this.id;
        typeLogin = 'Package';
        $('#modalLogin').modal('open');
    });

    $('.buyPackage').click(function () {
        //buyPackage(this.id);
        var id = this.id;
        $('#buyPackage'+this.id).on('submit', function (e) {
            e.preventDefault();

            if($('#typePackage'+id).val() == '2'){
                if($('#namePackage'+id).val() == '' || $('#emailPackage'+id).val() == '' || $('#phonePackage'+id).val() == ''
                || $('#countryPackage').val() == ''
                || $('#statePackage').val() == ''
                || $('#cityPackage').val() == ''
                || $('#addressPackage'+id).val() == ''
                ){
                    swal({
                        text: "Debes completar los campos requeridos",
                        icon: imageURL,
                        button: "OK!",
                    });
                    return false;
                }
            }

            let campo  = $("#emailPackage"+id).val();
            let emailRegex = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;
            if (emailRegex.test(campo.trim())) {
            } else {
                swal({
                    text: "Debe digitar un correo electrónico valido",
                    icon: imageURL,
                    button: "OK",
                });
                document.getElementById("emailPackage"+id).focus();
                return false;
            }

            if(!$("#terms"+id).is(':checked')){
                swal({
                    text: "Debes aceptar los terminos y condiciones",
                    icon: imageURL,
                    button: "OK!",
                });
                return false;
            }

            var data = $(this).serialize();
            swal({
                text: "Espere un momento",
                icon: imageURL,
                button: false,
                closeOnClickOutside: false,
            });
            $.ajax({
                url: https + "buyPackage",
                method: "POST",
                data: data,
                success: function (data) {
                    if ($.trim(data) == "complet") {
                        location.href = https + "payuPackage";
                    } else {
                        swal({
                            text: data,
                            icon: imageURL,
                            button: "OK!",
                        });
                    }
                }
            });
        });
        $('#buyPackage'+this.id).submit();
    });

    function buyPackage(id) {
        swal({
            text: "Espere un momento",
            icon: imageURL,
            button: false,
        });
        $.ajax({
            url: https + "buyPackage",
            method: "POST",
            data: {id: id, action: "buyPackage"},
            success: function (data) {
                if ($.trim(data) == "complet") {
                    location.href = https + "payuPackage";
                } else {
                    swal({
                        text: data,
                        icon: imageURL,
                        button: "OK!",
                    });
                }
            }
        });
    }


    //courses javascript
    $('.buyCourseLogin').click(function () {
        //alert(this.id);
        if(!$("#terms"+this.id).is(':checked')){
            swal({
                text: "Debes aceptar los terminos y condiciones",
                icon: imageURL,
                button: "OK!",
            });
            return false;
        }
        idLogin = this.id;
        typeLogin = 'Course';
        $('#modalLogin').modal('open');
    });
    function buyCourse(id) {
        if(!$("#terms"+id).is(':checked')){
            swal({
                text: "Debes aceptar los terminos y condiciones",
                icon: imageURL,
                button: "OK!",
            });
            return false;
        }

        swal({
            text: "Espere un momento",
            icon: imageURL,
            button: false,
        });
        $.ajax({
            url: https + "buyCourse",
            method: "POST",
            data: {id: id, action: "buyCourse"},
            success: function (data) {
                if ($.trim(data) == "complet") {
                    location.href = https + "payuCourse";
                } else {
                    swal({
                        text: "Ha ocurrido un error" + data,
                        icon: imageURL,
                        button: "OK!",
                    });
                }
            }
        });
    }
});
